module.exports = "<div class=\"{{ vm.adLocation }}\" ng-if=\"vm.ad\">\n    <button class=\"focusable\" ng-keydown=\"vm.select($event, vm.adLocation)\">\n        <img ng-src=\"{{ vm.ad.imageUrl }}\"/>\n    </button>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/news12Ad/news12Ad.html
 ** module id = 219
 ** module chunks = 0
 **/